"use client";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  EmailShareButton,
} from "react-share";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { handleStickyContent, triggerInfoBarOpened, triggerBackButtonVisibility } from "@/src/store/stickyInfoBar";

import FacebookIcon from "assets/svg/modal-share/facebook.svg";
import TwitterIcon from "assets/svg/modal-share/twitter.svg";
import WhatsappIcon from "assets/svg/modal-share/whatsapp.svg";
import LinkedinIcon from "assets/svg/modal-share/linkedin.svg";
import PinterestIcon from "assets/svg/modal-share/pinterest.svg";
import MailIcon from "assets/svg/modal-share/mail.svg";
import PeopleSvg from "assets/svg/people.svg";

import { createImageUrl } from "helpers/create-image-url";
import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Input from "components/common/input";
import Button from "components/common/button";
import { LazyImage } from "components/common/lazy-image/LazyImage";

import styles from "./styles.module.css";

const ModalShare = ({ media, title, url, listingId }) => {
  const fullPathUrl = url ? `${window.env.EJ_APP_CANONICAL_HOST}${url}` : window.env.EJ_APP_CANONICAL_HOST;
  const dispatch = useDispatch();

  const copyLinkToClipboard = (text) => {
    navigator?.clipboard?.writeText(text);
    dispatch(handleStickyContent("İlan bağlantısı kopyalandı"));
    dispatch(triggerBackButtonVisibility(false));
    dispatch(triggerInfoBarOpened());
  };

  const handleSocialMediaClickEvent = (clickedSocialMediaLabel) => {
    Ga4WithEventParameters({
      eventName: "share",
      eventParameters: {
        item_id: listingId?.toString(),
        item_type: "ilan",
        method: clickedSocialMediaLabel,
      },
    });
  };

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>İlanı Paylaş</h1>
      <div className={styles.infoWrap}>
        <div className={styles.image}>{media ? <LazyImage src={media} width={112} height={63} /> : <PeopleSvg />}</div>
        <div className={styles.listingTitle}>{title}</div>
      </div>
      <div className={styles.copy}>
        <span className={styles.areaTitle}>Linki Kopyala</span>
        <div className={styles.copyWrap}>
          <Input value={fullPathUrl} disabled />
          <Button outline size="M" onClick={() => copyLinkToClipboard(fullPathUrl)}>
            Kopyala
          </Button>
        </div>
      </div>
      <div className={styles.actionWrap}>
        <span className={styles.seperatorTitle}>Veya</span>
        <ul className={styles.list}>
          <li onClick={() => handleSocialMediaClickEvent("facebook")}>
            <FacebookShareButton url={fullPathUrl} description={title}>
              <FacebookIcon />
              <span className={styles.listName}>Facebook</span>
            </FacebookShareButton>
          </li>
          <li onClick={() => handleSocialMediaClickEvent("twitter")}>
            <TwitterShareButton url={fullPathUrl} title={title}>
              <TwitterIcon />
              <span className={styles.listName}>X</span>
            </TwitterShareButton>
          </li>
          <li onClick={() => handleSocialMediaClickEvent("whatsapp")}>
            <WhatsappShareButton url={fullPathUrl} title={title}>
              <WhatsappIcon />
              <span className={styles.listName}>Whatsapp</span>
            </WhatsappShareButton>
          </li>
          <li onClick={() => handleSocialMediaClickEvent("linkedin")}>
            <LinkedinShareButton url={fullPathUrl} title={title}>
              <LinkedinIcon />
              <span className={styles.listName}>Linkedin</span>
            </LinkedinShareButton>
          </li>
          <li onClick={() => handleSocialMediaClickEvent("pinterest")}>
            <PinterestShareButton
              url={fullPathUrl}
              description={title}
              media={createImageUrl(media, {
                width: 112,
                height: 63,
              })}
            >
              <PinterestIcon />
              <span className={styles.listName}>Pinterest</span>
            </PinterestShareButton>
          </li>
          <li onClick={() => handleSocialMediaClickEvent("email")}>
            <EmailShareButton url={fullPathUrl} subject={`Emlakjet: ${title}`}>
              <MailIcon />
              <span className={styles.listName}>Mail</span>
            </EmailShareButton>
          </li>
        </ul>
      </div>
    </div>
  );
};

ModalShare.propTypes = {
  media: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  listingId: PropTypes.number,
};

export default ModalShare;
